<template>
  <v-container fluid class="pa-4">
    <!-- Vista de Lista -->
    <div v-if="!mostrarFormulario">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <div>
            <div class="text-h4 font-weight-bold">
              <v-icon size="large" class="mr-2">mdi-package-variant</v-icon>
              Gestión de Catálogo
            </div>
            <div class="text-subtitle-2 text-grey mt-1">
              Administre servicios completos con secciones e items
            </div>
          </div>
          <v-btn color="primary" size="large" prepend-icon="mdi-plus" @click="crearNuevoServicio">
            Crear Servicio Completo
          </v-btn>
        </v-card-title>

        <v-divider class="mb-4" />

        <v-card-text>
          <!-- Filtros -->
          <v-row class="mb-4">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                label="Buscar servicio"
                prepend-inner-icon="mdi-magnify"
                clearable
                variant="outlined"
                density="compact"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="filterTipoEvento"
                :items="tiposEvento"
                item-title="NombreTipo"
                item-value="TipoEventoID"
                label="Tipo de Evento"
                clearable
                variant="outlined"
                density="compact"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="filterActivo"
                :items="estadosFilter"
                label="Estado"
                clearable
                variant="outlined"
                density="compact"
              />
            </v-col>
          </v-row>

          <!-- Tabla de Servicios -->
          <v-data-table
            :headers="headers"
            :items="filteredServicios"
            :loading="loading"
            :search="search"
            class="elevation-1"
          >
            <template #[`item.estadisticas`]="{ item }">
              <div class="d-flex gap-1">
                <v-chip size="small" color="info" variant="tonal">
                  <v-icon start size="small">mdi-folder</v-icon>
                  {{ item.TotalSecciones || 0 }} secciones
                </v-chip>
                <v-chip size="small" color="success" variant="tonal">
                  <v-icon start size="small">mdi-shape</v-icon>
                  {{ item.TotalItems || 0 }} items
                </v-chip>
              </div>
            </template>

            <template #[`item.Activo`]="{ item }">
              <v-chip :color="item.Activo ? 'success' : 'error'" size="small">
                {{ item.Activo ? 'Activo' : 'Inactivo' }}
              </v-chip>
            </template>

            <!-- <template #[`item.TipoEvento`]="{ item }">
              <v-chip v-if="item.TipoEvento" color="purple" size="small" variant="tonal">
                {{ item.TipoEvento }}
              </v-chip>
              <span v-else class="text-grey">Todos</span>
            </template> -->

            <template #[`item.actions`]="{ item }">
              <v-btn
                icon="mdi-eye"
                size="small"
                variant="text"
                color="info"
                @click="verDetalle(item)"
              />
              <!-- <v-btn
                icon="mdi-content-copy"
                size="small"
                variant="text"
                color="primary"
                @click="duplicarServicio(item)"
              /> -->
              <!-- <v-btn
                :icon="item.Activo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'"
                size="small"
                variant="text"
                :color="item.Activo ? 'warning' : 'success'"
                @click="toggleEstado(item)"
              /> -->
              <v-btn
                icon="mdi-delete"
                size="small"
                variant="text"
                color="error"
                @click="confirmDelete(item)"
              />
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- Información de ayuda -->
      <v-card class="mt-4" variant="outlined">
        <v-card-text>
          <v-alert type="info" variant="tonal" prominent>
            <template #prepend>
              <v-icon>mdi-information</v-icon>
            </template>
            <div class="text-h6 mb-2">Gestión Simplificada</div>
            <p class="mb-2">
              En esta vista puede crear servicios completos incluyendo todas sus secciones e
              items en un solo paso:
            </p>
            <ul class="ml-4">
              <li>Configure la información general del servicio</li>
              <li>Agregue todas las secciones que necesite</li>
              <li>Añada items con precios a cada sección</li>
              <li>Guarde todo de una sola vez</li>
            </ul>
            <p class="mt-2 mb-0">
              <v-icon size="small" class="mr-1">mdi-lightbulb</v-icon>
              <strong>Consejo:</strong> Puede duplicar servicios existentes para agilizar la
              creación de servicios similares.
            </p>
          </v-alert>
        </v-card-text>
      </v-card>
    </div>

    <!-- Vista de Formulario de Creación -->
    <div v-else>
      <CrearServicioCompleto @back="cerrarFormulario" @saved="onServicioGuardado" />
    </div>

    <!-- ============================================ -->
    <!-- Dialog de detalle CON EDICIÓN COMPLETA -->
    <!-- ============================================ -->
    <v-dialog v-model="dialogDetalle" max-width="1200px" scrollable persistent>
      <v-card v-if="servicioDetalle">
        <v-card-title class="bg-primary text-white">
          <div class="d-flex justify-space-between align-center w-100">
            <span>
              <v-icon start>mdi-briefcase</v-icon>
              {{ modoEdicion ? 'Editar Servicio' : servicioDetalle.NombreServicio }}
            </span>
            <div class="d-flex gap-2">
              <!-- Botón para activar/desactivar modo edición -->
              <v-btn
                v-if="!modoEdicion"
                icon="mdi-pencil"
                variant="text"
                @click="activarEdicion"
                title="Editar servicio completo"
              />
              <!-- Botón guardar (solo visible en modo edición) -->
              <v-btn
                v-if="modoEdicion"
                icon="mdi-content-save"
                variant="text"
                :loading="guardando"
                @click="guardarCambios"
                title="Guardar cambios"
              />
              <!-- Botón cancelar edición -->
              <v-btn
                v-if="modoEdicion"
                icon="mdi-close"
                variant="text"
                @click="cancelarEdicion"
                title="Cancelar edición"
              />
              <!-- Botón cerrar modal -->
              <v-btn
                v-if="!modoEdicion"
                icon="mdi-close"
                variant="text"
                @click="cerrarModal"
              />
            </div>
          </div>
        </v-card-title>

        <v-card-text style="max-height: 600px" class="pt-4">
          <!-- Información del servicio -->
          <v-card variant="outlined" class="mb-4">
            <v-card-title class="bg-grey-lighten-4">
              Información del Servicio
            </v-card-title>
            <v-card-text class="pt-4">
              <v-row v-if="!modoEdicion">
                <!-- <v-col cols="12" md="6">
                  <div class="text-subtitle-2 text-grey">Tipo de Evento</div>
                  <div class="text-body-1">
                    {{ servicioDetalle.TipoEvento || 'Todos los tipos' }}
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="text-subtitle-2 text-grey">Estado</div>
                  <v-chip :color="servicioDetalle.Activo ? 'success' : 'error'" size="small">
                    {{ servicioDetalle.Activo ? 'Activo' : 'Inactivo' }}
                  </v-chip>
                </v-col> -->
                <v-col v-if="servicioDetalle.Descripcion" cols="12">
                  <div class="text-subtitle-2 text-grey">Descripción</div>
                  <div class="text-body-1">{{ servicioDetalle.Descripcion }}</div>
                </v-col>
              </v-row>

              <!-- Modo Edición - Formulario -->
              <v-row v-else>
                <v-col cols="12" md="10">
                  <v-text-field
                    v-model="servicioEditable.NombreServicio"
                    label="Nombre del Servicio *"
                    variant="outlined"
                    density="comfortable"
                    prepend-inner-icon="mdi-package-variant"
                  />
                </v-col>

                <v-col cols="12" md="2">
                  <v-switch
                    v-model="servicioEditable.Activo"
                    label="Estado"
                    color="success"
                    :true-value="1"
                    :false-value="0"
                    hide-details
                  />
                </v-col>
                <!-- <v-col cols="12" md="4">
                  <v-select
                    v-model="servicioEditable.TipoEventoID"
                    :items="tiposEvento"
                    item-title="NombreTipo"
                    item-value="TipoEventoID"
                    label="Tipo de Evento"
                    variant="outlined"
                    density="comfortable"
                    clearable
                  />
                </v-col> -->
                <v-col cols="12">
                  <v-textarea
                    v-model="servicioEditable.Descripcion"
                    label="Descripción"
                    variant="outlined"
                    density="comfortable"
                    rows="2"
                  />
                </v-col>
                <!-- <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="servicioEditable.Orden"
                    label="Orden"
                    type="number"
                    variant="outlined"
                    density="comfortable"
                  />
                </v-col> -->
              </v-row>
            </v-card-text>
          </v-card>

          <v-divider class="my-4" />

          <!-- Secciones e Items -->
          <div class="d-flex justify-space-between align-center mb-3">
            <div class="text-h6">
              <v-icon class="mr-2">mdi-view-grid</v-icon>
              Secciones e Items
            </div>
            <!-- Botón agregar sección (solo en modo edición) -->
            <v-btn
              v-if="modoEdicion"
              color="primary"
              size="small"
              prepend-icon="mdi-plus"
              @click="agregarSeccion"
            >
              Agregar Sección
            </v-btn>
          </div>

          <!-- MODO VISTA (Solo lectura) -->
          <v-expansion-panels v-if="!modoEdicion && seccionesDetalle.length > 0">
            <v-expansion-panel
              v-for="seccion in seccionesDetalle"
              :key="seccion.SeccionID"
              class="mb-2"
            >
              <v-expansion-panel-title>
                <div class="d-flex align-center justify-space-between w-100 pr-4">
                  <div class="d-flex align-center">
                    <v-icon class="mr-3" color="secondary">mdi-folder</v-icon>
                    <div>
                      <div class="font-weight-bold">{{ seccion.NombreSeccion }}</div>
                      <div class="text-caption text-grey">
                        {{ seccion.items?.length || 0 }} item(s)
                      </div>
                    </div>
                  </div>
                  <v-chip
                    :color="seccion.Activo ? 'success' : 'error'"
                    size="small"
                    variant="tonal"
                  >
                    {{ seccion.Activo ? 'Activo' : 'Inactivo' }}
                  </v-chip>
                </div>
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-list v-if="seccion.items && seccion.items.length > 0">
                  <v-list-item
                    v-for="item in seccion.items"
                    :key="item.ItemID"
                    class="mb-2 border rounded"
                  >
                    <v-list-item-title class="font-weight-medium">
                      {{ item.NombreItem }}
                    </v-list-item-title>

                    <v-list-item-subtitle v-if="item.Descripcion" class="mt-1">
                      {{ item.Descripcion }}
                    </v-list-item-subtitle>

                    <template #append>
                      <div class="text-right">
                        <div class="text-h6 text-primary font-weight-bold">
                          {{ formatCurrency(item.PrecioUnitario) }}
                        </div>
                        <v-chip
                          :color="item.Activo ? 'success' : 'error'"
                          size="x-small"
                          class="mt-1"
                        >
                          {{ item.Activo ? 'Activo' : 'Inactivo' }}
                        </v-chip>
                      </div>
                    </template>
                  </v-list-item>
                </v-list>
                <v-alert v-else type="info" variant="tonal" density="compact">
                  No hay items en esta sección
                </v-alert>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- MODO EDICIÓN (Con drag & drop) -->
          <div v-if="modoEdicion">
            <v-expansion-panels v-model="panelsAbiertos" multiple  style="display: block;">
              <draggable
                v-model="seccionesEditable"
                handle=".drag-handle-seccion"
                item-key="tempId"
                @end="onSeccionReordered"
              >
                <template #item="{ element: seccion, index: seccionIndex }">
                  <v-expansion-panel :key="seccion.tempId" class="mb-3">
                    <v-expansion-panel-title>
                      <template #default="{ expanded }">
                        <div class="d-flex align-center justify-space-between w-100 pr-4">
                          <div class="d-flex align-center flex-grow-1">
                            <v-icon class="drag-handle-seccion mr-3" style="cursor: move">
                              mdi-drag
                            </v-icon>
                            <v-icon class="mr-3" color="secondary">mdi-folder</v-icon>
                            <div v-if="!expanded" class="font-weight-bold">
                              {{ seccion.NombreSeccion || 'Nueva Sección' }}
                            </div>
                            <div class="ml-4 d-flex gap-2" v-if="!expanded">
                              <v-chip size="small" color="info" variant="tonal">
                                {{ seccion.items?.length || 0 }} items
                              </v-chip>
                              <v-chip
                                size="small"
                                :color="seccion.Activo ? 'success' : 'error'"
                                variant="tonal"
                              >
                                {{ seccion.Activo ? 'Activo' : 'Inactivo' }}
                              </v-chip>
                            </div>
                          </div>
                          <v-btn
                            icon="mdi-delete"
                            size="small"
                            variant="text"
                            color="error"
                            @click.stop="eliminarSeccion(seccionIndex)"
                          />
                        </div>
                      </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text>
                      <!-- Formulario de la sección -->
                      <v-card flat class="mb-4">
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" md="8">
                              <v-text-field
                                v-model="seccion.NombreSeccion"
                                label="Nombre de la Sección *"
                                variant="outlined"
                                density="compact"
                                prepend-inner-icon="mdi-folder"
                              />
                            </v-col>
                            <!-- <v-col cols="12" md="2">
                              <v-text-field
                                v-model.number="seccion.Orden"
                                label="Orden"
                                type="number"
                                variant="outlined"
                                density="compact"
                              />
                            </v-col> -->
                            <v-col cols="12" md="2">
                              <v-switch
                                v-model="seccion.Activo"
                                label="Activa"
                                color="success"
                                :true-value="1"
                                :false-value="0"
                                hide-details
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>

                      <v-divider class="my-4" />

                      <!-- Items de la sección -->
                      <div class="d-flex justify-space-between align-center mb-3">
                        <span class="text-subtitle-1 font-weight-bold">
                          <v-icon size="small" class="mr-1">mdi-shape</v-icon>
                          Items
                        </span>
                        <v-btn
                          color="primary"
                          size="small"
                          variant="tonal"
                          prepend-icon="mdi-plus"
                          @click="agregarItem(seccionIndex)"
                        >
                          Agregar Item
                        </v-btn>
                      </div>

                      <!-- Lista de items -->
                      <div
                        v-if="!seccion.items || seccion.items.length === 0"
                        class="text-center py-4 bg-grey-lighten-5 rounded"
                      >
                        <v-icon color="grey-lighten-1">mdi-package-variant-closed</v-icon>
                        <p class="text-caption text-grey mt-2">No hay items en esta sección</p>
                      </div>

                      <draggable
                        v-else
                        v-model="seccion.items"
                        handle=".drag-handle-item"
                        item-key="tempId"
                        @end="onItemReordered(seccionIndex)"
                      >
                        <template #item="{ element: item, index: itemIndex }">
                          <v-card :key="item.tempId" variant="outlined" class="mb-3">
                            <v-card-text>
                              <v-row align="center">
                                <v-col cols="auto">
                                  <v-icon class="drag-handle-item" style="cursor: move">
                                    mdi-drag
                                  </v-icon>
                                </v-col>

                                <v-col cols="12" md="4">
                                  <v-text-field
                                    v-model="item.NombreItem"
                                    label="Nombre del Item *"
                                    variant="outlined"
                                    density="compact"
                                    hide-details="auto"
                                  />
                                </v-col>

                                <v-col cols="12" md="3">
                                  <v-text-field
                                    v-model.number="item.PrecioUnitario"
                                    label="Precio *"
                                    variant="outlined"
                                    density="compact"
                                    type="number"
                                    prefix="$"
                                    hide-details="auto"
                                  />
                                </v-col>

                                <!-- <v-col cols="6" md="1">
                                  <v-text-field
                                    v-model.number="item.Orden"
                                    label="Orden"
                                    variant="outlined"
                                    density="compact"
                                    type="number"
                                    hide-details="auto"
                                  />
                                </v-col> -->

                                <v-col cols="6" md="2">
                                  <v-switch
                                    v-model="item.Activo"
                                    label="Activo"
                                    color="success"
                                    :true-value="1"
                                    :false-value="0"
                                    hide-details
                                    density="compact"
                                  />
                                </v-col>

                                <v-col cols="auto">
                                  <v-btn
                                    icon="mdi-delete"
                                    size="small"
                                    variant="text"
                                    color="error"
                                    @click="eliminarItem(seccionIndex, itemIndex)"
                                  />
                                </v-col>
                              </v-row>

                              <!-- Descripción del item -->
                              <v-row
                                v-if="item.mostrarDescripcion || item.Descripcion"
                                class="mt-2"
                              >
                                <v-col cols="12">
                                  <v-textarea
                                    v-model="item.Descripcion"
                                    label="Descripción"
                                    variant="outlined"
                                    density="compact"
                                    rows="2"
                                    hide-details
                                  />
                                </v-col>
                              </v-row>

                              <v-row v-else class="mt-1">
                                <v-col cols="12">
                                  <v-btn
                                    size="x-small"
                                    variant="text"
                                    prepend-icon="mdi-plus"
                                    @click="item.mostrarDescripcion = true"
                                  >
                                    Agregar descripción
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </template>
                      </draggable>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </template>
              </draggable>
            </v-expansion-panels>
          </div>

          <!-- Mensaje cuando no hay secciones -->
          <v-alert
            v-if="seccionesDetalle.length === 0 && !modoEdicion"
            type="info"
            variant="tonal"
          >
            Este servicio no tiene secciones configuradas
          </v-alert>

          <v-alert
            v-if="seccionesEditable.length === 0 && modoEdicion"
            type="info"
            variant="tonal"
          >
            No hay secciones. Haz clic en "Agregar Sección" para comenzar.
          </v-alert>
        </v-card-text>

        <!-- Acciones del modal -->
        <v-card-actions class="px-6 pb-4">
          <v-spacer />
          <v-btn
            v-if="!modoEdicion"
            color="grey"
            variant="text"
            @click="cerrarModal"
          >
            Cerrar
          </v-btn>
          <v-btn
            v-if="!modoEdicion"
            color="primary"
            variant="elevated"
            @click="activarEdicion"
          >
            Editar
          </v-btn>
          <template v-else>
            <v-btn color="grey" variant="text" @click="cancelarEdicion">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              variant="elevated"
              prepend-icon="mdi-content-save"
              :loading="guardando"
              @click="guardarCambios"
            >
              Guardar Cambios
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de confirmación de eliminación -->
    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confirmar Eliminación</v-card-title>
        <v-card-text>
          <v-alert type="warning" variant="tonal" prominent>
            <p class="mb-2">
              ¿Está seguro de eliminar el servicio
              <strong>{{ itemToDelete?.NombreServicio }}</strong>?
            </p>
            <p class="mb-0">
              Esta acción eliminará también todas las secciones e items asociados y no se puede
              deshacer.
            </p>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" variant="text" @click="deleteDialog = false">Cancelar</v-btn>
          <v-btn color="error" variant="elevated" :loading="deleting" @click="deleteItem">
            Eliminar Todo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000">
      {{ snackbarText }}
      <template #actions>
        <v-btn variant="text" @click="snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
// import axios from 'axios'
import CrearServicioCompleto from '@/views/services/Crearserviciocompleto.vue'
import { useStore } from 'vuex'
import draggable from 'vuedraggable'
defineOptions({
  name: 'services.view'
})
// API Base URL
// const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost/api'

const store = useStore()

// Estado
const loading = ref(false)
const deleting = ref(false)
const guardando = ref(false)
const mostrarFormulario = ref(false)
const dialogDetalle = ref(false)
const deleteDialog = ref(false)
const modoEdicion = ref(false)
const search = ref('')
const filterTipoEvento = ref(null)
const filterActivo = ref(null)
const panelsAbiertos = ref([])

// Datos
const servicios = ref([])
const secciones = ref([])
const items = ref([])
const tiposEvento = ref([])
const itemToDelete = ref(null)
const servicioDetalle = ref(null)
const seccionesDetalle = ref([])

// Datos editables (copias para edición)
const servicioEditable = ref(null)
const seccionesEditable = ref([])

// Snackbar
const snackbar = ref(false)
const snackbarText = ref('')
const snackbarColor = ref('success')

// Headers
const headers = [
  { title: 'ID', key: 'ServicioID', sortable: true, width: '80px' },
  { title: 'Nombre', key: 'NombreServicio', sortable: true },
  // { title: 'Tipo de Evento', key: 'TipoEvento', sortable: true },
  { title: 'Estadísticas', key: 'estadisticas', sortable: false },
  // { title: 'Orden', key: 'Orden', sortable: true, width: '80px' },
  { title: 'Estado', key: 'Activo', sortable: true, width: '100px' },
  { title: 'Acciones', key: 'actions', sortable: false, align: 'center', width: '200px' }
]

const estadosFilter = [
  { title: 'Activos', value: true },
  { title: 'Inactivos', value: false }
]

// Computed
const filteredServicios = computed(() => {
  let filtered = [...servicios.value]

  if (filterTipoEvento.value !== null) {
    filtered = filtered.filter(
      s => Number(s.TipoEventoID) === Number(filterTipoEvento.value)
    )
  }

  if (filterActivo.value !== null) {
    filtered = filtered.filter(
      s => Boolean(s.Activo) === Boolean(filterActivo.value)
    )
  }

  return filtered
})

// Métodos
const loadCatalog = async () => {
  loading.value = true
  await store.dispatch('Cotizacion/fetchCatalogo')
  
  const catalogoData = store.state.Cotizacion.Catalogo.data.data
  servicios.value = catalogoData.servicios
  secciones.value = catalogoData.secciones
  items.value = catalogoData.items
  
  // Calcular estadísticas
  servicios.value.forEach((servicio) => {
    const seccionesServicio = secciones.value.filter(
      (s) => s.ServicioID === servicio.ServicioID
    )
    servicio.TotalSecciones = seccionesServicio.length

    const itemsServicio = items.value.filter((item) =>
      seccionesServicio.some((sec) => sec.SeccionID === item.SeccionID)
    )
    servicio.TotalItems = itemsServicio.length
  })
  
  loading.value = false
}

const fetchTiposEvento = async () => {
  await store.dispatch('Cotizacion/getTiposEvento')
  tiposEvento.value = store.state.Cotizacion.TiposEvento.data.data
}

const crearNuevoServicio = () => {
  mostrarFormulario.value = true
}

const cerrarFormulario = () => {
  mostrarFormulario.value = false
}

const onServicioGuardado = () => {
  loadCatalog()
}

const verDetalle = (item) => {
  servicioDetalle.value = item
  modoEdicion.value = false

  // Obtener secciones del servicio
  const seccionesServicio = secciones.value.filter(
    (s) => s.ServicioID === item.ServicioID
  )

  // Agregar items a cada sección
  seccionesDetalle.value = seccionesServicio.map((seccion) => ({
    ...seccion,
    items: items.value.filter((i) => i.SeccionID === seccion.SeccionID)
  }))

  dialogDetalle.value = true
}

// ============================================
// NUEVOS MÉTODOS PARA EDICIÓN EN MODAL
// ============================================

const activarEdicion = () => {
  modoEdicion.value = true
  
  // Crear copias para editar
  servicioEditable.value = { ...servicioDetalle.value }
  
  seccionesEditable.value = seccionesDetalle.value.map(seccion => ({
    ...seccion,
    tempId: `sec_${seccion.SeccionID || Date.now()}_${Math.random()}`,
    items: (seccion.items || []).map(item => ({
      ...item,
      tempId: `item_${item.ItemID || Date.now()}_${Math.random()}`,
      mostrarDescripcion: !!item.Descripcion
    }))
  }))
  
  // Abrir todos los panels
  panelsAbiertos.value = seccionesEditable.value.map((_, index) => index)
}

const cancelarEdicion = () => {
  if (confirm('¿Descartar los cambios realizados?')) {
    modoEdicion.value = false
    servicioEditable.value = null
    seccionesEditable.value = []
  }
}

const cerrarModal = () => {
  dialogDetalle.value = false
  modoEdicion.value = false
  servicioEditable.value = null
  seccionesEditable.value = []
}

const agregarSeccion = () => {
  const nuevaSeccion = {
    tempId: `sec_${Date.now()}_${Math.random()}`,
    SeccionID: null,
    NombreSeccion: '',
    Orden: seccionesEditable.value.length + 1,
    Activo: 1,
    items: []
  }
  seccionesEditable.value.push(nuevaSeccion)
  
  // Abrir el panel de la nueva sección
  setTimeout(() => {
    panelsAbiertos.value.push(seccionesEditable.value.length - 1)
  }, 100)
}

const eliminarSeccion = (index) => {
  if (confirm('¿Estás seguro de eliminar esta sección y todos sus items?')) {
    seccionesEditable.value.splice(index, 1)
  }
}

const agregarItem = (seccionIndex) => {
  const nuevoItem = {
    tempId: `item_${Date.now()}_${Math.random()}`,
    ItemID: null,
    NombreItem: '',
    Descripcion: '',
    Precio: 0,
    Orden: (seccionesEditable.value[seccionIndex].items?.length || 0) + 1,
    Activo: 1,
    mostrarDescripcion: false
  }
  
  if (!seccionesEditable.value[seccionIndex].items) {
    seccionesEditable.value[seccionIndex].items = []
  }
  
  seccionesEditable.value[seccionIndex].items.push(nuevoItem)
}

const eliminarItem = (seccionIndex, itemIndex) => {
  if (confirm('¿Estás seguro de eliminar este item?')) {
    seccionesEditable.value[seccionIndex].items.splice(itemIndex, 1)
  }
}

const onSeccionReordered = () => {
  seccionesEditable.value.forEach((seccion, index) => {
    seccion.Orden = index + 1
  })
}

const onItemReordered = (seccionIndex) => {
  seccionesEditable.value[seccionIndex].items.forEach((item, index) => {
    item.Orden = index + 1
  })
}

const validarCambios = () => {
  if (!servicioEditable.value.NombreServicio?.trim()) {
    showSnackbar('El nombre del servicio es requerido', 'error')
    return false
  }

  if (seccionesEditable.value.length === 0) {
    showSnackbar('Debe agregar al menos una sección', 'error')
    return false
  }

  for (let i = 0; i < seccionesEditable.value.length; i++) {
    const seccion = seccionesEditable.value[i]
    if (!seccion.NombreSeccion?.trim()) {
      showSnackbar(`La sección ${i + 1} requiere un nombre`, 'error')
      return false
    }

    if (seccion.items && seccion.items.length > 0) {
      for (let j = 0; j < seccion.items.length; j++) {
        const item = seccion.items[j]
        if (!item.NombreItem?.trim()) {
          showSnackbar(
            `El item ${j + 1} de la sección "${seccion.NombreSeccion}" requiere un nombre`,
            'error'
          )
          return false
        }
        if (item.PrecioUnitario === null || item.PrecioUnitario === undefined) {
          showSnackbar(
            `El item "${item.NombreItem}" requiere un precio`,
            'error'
          )
          return false
        }
      }
    }
  }

  return true
}

const guardarCambios = async () => {
  if (!validarCambios()) return

  guardando.value = true

  try {
    const payload = {
      servicio: {
        ...servicioEditable.value,
        TipoEventoID: servicioEditable.value.TipoEventoID || null
      },
      secciones: seccionesEditable.value.map(seccion => ({
        SeccionID: seccion.SeccionID,
        NombreSeccion: seccion.NombreSeccion,
        Orden: seccion.Orden,
        Activo: seccion.Activo,
        items: (seccion.items || []).map(item => ({
          ItemID: item.ItemID,
          NombreItem: item.NombreItem,
          Descripcion: item.Descripcion || '',
          Precio: Number.parseFloat(item.PrecioUnitario),
          Orden: item.Orden,
          Activo: item.Activo
        }))
      }))
    }
    await store.dispatch('Cotizacion/actualizarServicioCompletoTransaccional', payload)
    deleting.value = false
    guardando.value = false
    loadCatalog()
    dialogDetalle.value = false
  } catch (error) {
    console.error('Error al guardar cambios:', error)
    showSnackbar(
      error.response?.data?.message || 'Error al guardar los cambios',
      'error'
    )
  } finally {
    guardando.value = false
  }
}

// ============================================
// FIN NUEVOS MÉTODOS
// ============================================

const duplicarServicio = async (item) => {
  showSnackbar('Función de duplicación en desarrollo', 'info')
}

const toggleEstado = async (item) => {
  // try {
  //   await axios.patch(`${API_BASE_URL}/servicios/${item.ServicioID}/estado`, {
  //     Activo: !item.Activo
  //   })
  //   showSnackbar('Estado actualizado exitosamente', 'success')
  //   loadCatalog()
  // } catch (error) {
  //   showSnackbar('Error al cambiar el estado', 'error')
  //   console.error(error)
  // }
}

const confirmDelete = (item) => {
  itemToDelete.value = item
  deleteDialog.value = true
}

const deleteItem = async () => {
  deleting.value = true
  await store.dispatch('Cotizacion/eliminarServicioCompletoTransaccional', itemToDelete.value)
  if(store.state.Cotizacion.result.success){
    deleteDialog.value = false
    loadCatalog()
  }
    deleting.value = false
}

const formatCurrency = (value) => {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0
  }).format(value)
}

const getFirstImage = (imagenes) => {
  if (!imagenes) return null
  try {
    const imgs = typeof imagenes === 'string' ? JSON.parse(imagenes) : imagenes
    return Array.isArray(imgs) && imgs.length > 0 ? imgs[0] : null
  } catch {
    return null
  }
}

const showSnackbar = (text, color = 'success') => {
  snackbarText.value = text
  snackbarColor.value = color
  snackbar.value = true
}

// Lifecycle
onMounted(() => {
  loadCatalog()
  fetchTiposEvento()
})
</script>

<style scoped>
.gap-1 {
  gap: 4px;
}

.gap-2 {
  gap: 8px;
}

.border {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.drag-handle-seccion,
.drag-handle-item {
  cursor: move;
}

.drag-handle-seccion:hover,
.drag-handle-item:hover {
  color: #1976d2;
}
</style>